import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from '../Navbar';
import Contact from '../Contact';
import Stages from './Workflow';
import { useState,  } from 'react';
import { useParams } from 'react-router-dom';
import { project } from "../data/portfolio";
import * as FaIcons from "react-icons/fa";
import * as SiIcons from "react-icons/si";
import { Container, Row, Col, Card } from "react-bootstrap";
import { IoAirplane, IoBagSharp, IoPerson } from "react-icons/io5";
import Screen from './Screen'
const PortfolioPage = () => {

   const [isFilled, setIsFilled] = useState(false);
   const { id } = useParams();
const myProject = project.find((p) => p.id === id);
  return (
    <>
<section className="brand-hero">
        <div className="animated-bg"></div>
        <div className="container h-200">
          <div className="align-items-center justify-content-between">
           
              <div className="brand-content">
                <h1
                  className={`brand-name ${isFilled ? 'filled' : ''}`}
                  onClick={() => setIsFilled(!isFilled)}
                >
                {myProject.heroTitle}
                </h1>
              
              </div>
          </div>
        </div>
        
  <div className="circle-transition"></div>
      <section className="white-section">
        <div className="">
        <img src={myProject.heroImage} height="700px" alt='' />
        
        </div>
      </section>
</section>

<style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
          /* Full screen section for TECHBRAND */
  /* Full screen section for TECHBRAND */
        .brand-hero {
          height: 170vh;         
          width: 100%;           
          display: flex;
          flex-direction: column;
          align-items: center;  
          justify-content: center;
          background: #000;    
          color: #fff;
          position: relative;
          overflow: visible;
        }

 .circle-transition {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50vw; 
  background: #fff;
  border-radius: 50% 50% 0 0;
  clip-path: ellipse(60% 100% at 50% 100%);
  z-index: 1;
  overflow: hidden;
}
       
.white-section {
          background: #fff;
          position: relative;
          z-index: 2;
        }

  


/* TECHBRAND title */
.brand-title {
  height: 500px;       
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 5rem; 
  font-weight: bold;
  margin: 0;
}
.brand-tagline {
  font-size: 1.5rem;
  margin-top: 20px;
}

/* GIF block */
.gif-section {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #111; /* optional background */
  padding: 40px 0;
}

.brand-content {
  height: 100vh;
  width: 100%;  display: flex;
align-items: center;
  justify-content: center;
}
.animated-bg {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: 
            radial-gradient(circle at 20% 50%, rgba(131, 9, 246, 0.3) 0%, transparent 50%),
            radial-gradient(circle at 80% 50%, rgba(18, 10, 240, 0.3) 0%, transparent 50%);
          animation: pulse 4s ease-in-out infinite;
        }
        @keyframes pulse {
          0%, 100% {
            opacity: 0.8;
          }s
          50% {
            opacity: 1;
          }
        }

        .container {
          position: relative;
          z-index: 2;
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .brand-content {
          animation: slideInLeft 0.8s ease-out;
        }

        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        .brand-name {
          font-size: clamp(10rem, 6vw, 5rem);
          font-weight: 900;
          letter-spacing: 0.05em;
          color: transparent;
          -webkit-text-stroke: 3px white;
          text-stroke: 3px white;
          cursor: pointer;
          transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
          user-select: none;
          margin: 0;
          line-height: 1;
          widt
          position: relative;
          display: inline-block;
        }



        .brand-name.filled {
          color: white;
          -webkit-text-stroke: 3px white;
          text-stroke: 3px white;
          text-shadow: 
            0 0 20px rgba(255, 255, 255, 0.8),
            0 0 40px rgba(255, 255, 255, 0.5),
            0 0 60px rgba(255, 255, 255, 0.3);
          transform: scale(1.05);
        }

        .brand-name:hover {
          color: white;
          -webkit-text-stroke: 3px white;
          text-stroke: 3px white;
          text-shadow: 
            0 0 20px rgba(255, 255, 255, 0.8),
            0 0 40px rgba(255, 255, 255, 0.5),
            0 0 60px rgba(255, 255, 255, 0.3);
          transform: scale(1.05);
        }

        .brand-name.filled:hover {
          transform: scale(1.05);
        }

        .brand-tagline {
          color: rgba(255, 255, 255, 0.9);
          font-size: clamp(0.9rem, 2vw, 1.2rem);
          font-weight: 300;
          letter-spacing: 0.15em;
          margin-top: 10px;
          opacity: 0;
          animation: fadeIn 1s ease-out 0.3s forwards;
        }

        @keyframes fadeIn {
          to {
            opacity: 1;
          }
        }

        .gif-container {
          position: relative;
          display: inline-block;
          animation: slideInRight 0.8s ease-out;
        }

        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translateX(50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        .gif-glow {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 120%;
          height: 120%;
          background: radial-gradient(circle, rgba(255, 255, 255, 0.3) 0%, transparent 70%);
          border-radius: 20px;
          animation: glow 2s ease-in-out infinite;
          z-index: -1;
        }

        @keyframes glow {
          0%, 100% {
            opacity: 0.5;
            transform: translate(-50%, -50%) scale(1);
          }
          50% {
            opacity: 0.8;
            transform: translate(-50%, -50%) scale(1.1);
          }
        }

        .brand-gif {
          max-height: 50vh;
          min-height: 100%;
          width: auto;
          max-width: 100%;
          border-radius: 16px;
          box-shadow: 
            0 10px 40px rgba(0, 0, 0, 0.4),
            0 0 0 1px rgba(255, 255, 255, 0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          display: block;
        }

        .brand-gif:hover {
          transform: scale(1.05) rotate(2deg);
          box-shadow: 
            0 15px 50px rgba(0, 0, 0, 0.5),
            0 0 0 2px rgba(255, 255, 255, 0.2);
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0) rotate(0deg);
          }
          50% {
            transform: translateY(-20px) rotate(180deg);
          }
        }

        @media (max-width: 768px) {
          .brand-hero {
            min-height: 180px;
          }

          .row {
            flex-direction: column;
            text-align: center;
          }

          .brand-name {
          
            -webkit-text-stroke: 2px white;
            text-stroke: 2px white;
          }

          .brand-tagline {
            font-size: 0.9rem;
            margin-bottom: 15px;
          }

          .gif-container {
            margin-top: 10px;
          }

          .shape {
            display: none;
          }
        }
`}</style>

<br />
<br />
<br />
<br />
<br />
    <div style={{ 
      background: 'linear-gradient(135deg, #ffffff 0%, #f5f7fa 50%, #e8ecf1 100%)',
      minHeight: '100vh'
    }}>
        <Navbar />
        
       <h1 className='p-4' style={{
  fontSize: '3.5rem',
  fontWeight: '800',
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  textAlign: 'center',
  letterSpacing: '-0.02em',
  lineHeight: '1.2',
  textShadow: '0 4px 20px rgba(102, 126, 234, 0.3)',
  animation: 'fadeInUp 0.8s ease-out',
}}>
  {myProject.heroHeading}
</h1>
<p style={{fontSize: "1.6rem"}} className='p-4 text-center'>{myProject.description}</p>

      
        
        
       {/* ===== Section 1: Project Details + Client Card ===== */}
<section>
  <h1 className="text-center">{myProject.detailsSections[0].heading}</h1>
  <br />
  <br />
  <br />
  <Container>
    <Row>
      <Col md={6}>
        {myProject.detailsSections[0].texts.map((text, idx) => (
          <p style={{fontSize: "1.6rem"}} key={idx} className="mb-3">
            {text}
          </p>
        ))}
      </Col>
      <Col md={6}>
        <Card
          style={{
            background: "linear-gradient(90deg,rgb(32, 29, 203), #fffdfe)",
            borderRadius: myProject.detailsSections[0].card.borderRadius,
            color: myProject.detailsSections[0].card.color,
            width: myProject.detailsSections[0].card.width,
            height: myProject.detailsSections[0].card.height,
          }}
        >
          <div className="d-flex justify-content-center align-items-center mt-4">
            <IoPerson className="text-center h1" size={60} />
          </div>
          <h3 className="pt-4 pb-4 text-center">
            {myProject.detailsSections[0].card.title}
          </h3>
          <h5 className="p-3 text-light">
            {myProject.detailsSections[0].card.description}
          </h5>
        </Card>
      </Col>
    </Row>
  </Container>
</section>

{/* ===== Section 2: Two Cards Side by Side ===== */}
<section>
  <br />
  <br />
  <Container>
    <Row>
      <Col className="md-2"></Col> {/* Spacer */}

      {myProject.detailsSections[1].cards.map((card, idx) => (
        <Col key={idx} className="md-5">
          <Card
            style={{
              background: "linear-gradient(90deg,rgb(32, 29, 203), #fffdfe)",
              borderRadius: card.borderRadius,
              color: card.color,
              width: card.width,
              height: card.height,
            }}
          >
            <div className="d-flex justify-content-center align-items-center mt-4">
              {idx === 0 ? <IoBagSharp className="text-center h1" size={60} /> : <IoAirplane className="text-center h1" size={60} />}
            </div>
            <h3 className="pt-4 pb-4 text-center">{card.title}</h3>
            <h5 className="p-4 text-light">{card.description}</h5>
          </Card>
        </Col>
      ))}
    </Row>
  </Container>
</section>

<br />
<br />
<section className="py-5 bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <h1 className="display-5 fw-bold mb-3">Technology Stack</h1>
            <h5 className="lead text-muted">Powered by modern and robust technologies</h5>
          </div>

          <div className="row g-4">
            {myProject.technologies.map((tech, idx) => (
              <div key={idx} className="col-md-6 col-lg-3">
                <div className="card h-100 shadow-sm border-0 hover-card">
                  <div className="card-body">
                    <h5 className="card-title text-center mb-4 mt-4 fw-bold">{tech.category}</h5>
                    <div className="d-flex flex-column gap-3">
                      {tech.items.map((item, index) => {
                        const Icon = FaIcons[item.icon] || SiIcons[item.icon] || FaIcons.FaReact;
                        return (
                          <div key={index} className="d-flex align-items-center p-2 rounded tech-item">
                            <div className="me-3" style={{ fontSize: "2rem", color: item.color }}>
                              <Icon />
                            </div>
                            <span className="fw-medium">{item.name}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div 
     
style={{ 
  background: '#8d92ff', 
  height: '100vh', 
  display: 'flex', 
  alignItems: 'center' 
}}>
{myProject.sections
  .filter(sec => sec.title === "Mobile & Web Screens")
  .map((sec, index) => (
    <div
     className='container'
      key={index}
      style={{
        background: sec.background || "#8d92ff",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div className="container d-flex justify-content-center  align-items-center">
        <div className="row">
          
          {/* Left side text */}
          {!sec.reverse && (
            <div className="col-md-6">
              <h2 style={{ color: "white", fontWeight: "bold" }}>{sec.title}</h2>
              <h4 style={{ color: "white", marginTop: "10px" }}>{sec.subtitle}</h4>
              {sec.description.map((para, i) => (
                <p
                  key={i}
                  style={{ color: "white", marginTop: "20px", lineHeight: "1.8" }}
                >
                  {para}
                </p>
              ))}
            </div>
          )}

          {/* Right side image */}
          <div className={`col-md-6 text-center ${sec.reverse ? "order-first" : ""}`}>
            <img
            
              src={sec.image}
              alt={sec.title}
              style={{
                maxWidth: "100%",
                height: "auto",
                borderRadius: "15px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
              }}
              
            />
          </div>

          {/* If image should be on left */}
          {sec.reverse && (
            <div className="col-md-6">
              <h2 style={{ color: "white", fontWeight: "bold" }}>{sec.title}</h2>
              <h4 style={{ color: "white", marginTop: "10px" }}>{sec.subtitle}</h4>
              {sec.description.map((para, i) => (
                <p
                  key={i}
                  style={{ color: "white", marginTop: "20px", lineHeight: "1.8" }}
                >
                  {para}
                </p>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
))}

</div>
 </div>
 <div>
 <img src="https://d19cx7uv5wsln6.cloudfront.net/assets/images/dr-skin-screen-mobiles.webp" alt='' style={{ maxWidth: "100%", height: "auto" }} /></div>
<Screen />
<Stages />
<br />
<br />
<br />
<br />
<br />
<br />

    <div className="container my-5">
      <div 
        className="position-relative rounded-pill d-flex align-items-center justify-content-between p-5"
        style={{
          background: 'linear-gradient(135deg, #8b9bff 0%, #a8b5ff 100%)',
          minHeight: '200px',
          overflow: 'hidden',

        }}
      >
        {/* Quote Icon */}
        <div 
          className="position-absolute"
          style={{
            top: '40px',
            left: '60px',
            fontSize: '80px',
            color: 'rgba(255, 255, 255, 0.3)',
            fontFamily: 'Georgia, serif',
            lineHeight: '1',
            marginTop: "30px",
          }}
        >
          "
        </div>

        {/* Testimonial Text */}
        <div className="col-md-7 ps-5">
          <h2 
            className="text-white fw-bold mb-0"
            style={{
              fontSize: '2rem',
              lineHeight: '1.4',
              marginTop: "30px",
               marginBottom: "40px"
            }}
          >
            Our collaboration with the AI Speed Enforcement team has been highly successful. The team maintained clear and consistent communication throughout every stage, ensuring smooth deployment and effective results.
          </h2>
        </div>

        {/* Logo Container */}
        <div className="col-md-5 d-flex justify-content-end pe-4">
          <div 
            className="bg-white rounded-pill d-flex align-items-center justify-content-center"
            style={{
              width: '400px',
              height: '140px',
              padding: '30px 60px'
            }}
          >
            <span 
              style={{
                fontSize: '4rem',
                fontWeight: '600',
                color: '#8b9bff',
                fontFamily: 'Arial, sans-serif',
                letterSpacing: '-2px'
              }}
            >
              SAFETY.AI
            </span>
          </div>
        </div>
      </div>

      {/* Bootstrap CSS CDN - Add this to your index.html or import in your app */}
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
        rel="stylesheet"
      />
    </div>
<br />
<br />
<br />
<br />
<br />
<br />
      <Contact />

    </>
  );
};

export default PortfolioPage;